import React, { Component } from "react";
import { Link } from 'react-router-dom'
import dotenv from 'dotenv';
import Helper from '../DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,

} from "../../reducers/dev";

import { Card, Button, Row, Col, Accordion } from 'react-bootstrap';

import SP_01a_FieldEditor from "./SP_01a_FieldEditor"
import Test from "./Test"
//import Xd from "./Xd"
/*
import Helper from "../LocServices/Helper"
import { login } from "../../actions/auth"; */
/* import { reqLocId_findInfo, 

} from "../../reducers/location"; */



dotenv.config();

class ServicePage extends Component {
/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
  }
  componentDidUpdate(prevProps) {
    // Check if the URL has changed
    
/*     if (this.props.match.params.collection_id !== prevProps.match.params.collection_id) {
      const rx_collection_id = this.props.match.params.collection_id

      this.props.t_get_sensors_collection_by_id(rx_collection_id) // Fetch new data
      
    } */
}

  componentDidMount(){
    //if (this.props.user) this.props.thunkTest(this.props.user.accessToken)
  }


  render() {
        // Check if the user is authenticated or exists
        if (!this.props.user) {
          // Redirect to an external URL
          //window.location.href = "https://google.com";
          window.location.href = process.env.REACT_APP_HOST+"/login";
          return null; // Return null to avoid rendering anything else
        }
    //if (this.props.user) return <Redirect to="/login" />;
    //const o = this.props.dev.sensors_collection_id.data_10_days_back.collection_info_by_id

    return (
      <>
    <div className="container mt-5">
        {/* <Test /> */}
    <h3 className="text-info">Hello Service Page</h3>
    <Accordion defaultActiveKey={['0']} alwaysOpen>
    <Accordion.Item >
          <Accordion.Header> 
          Device Field Bulk Editor
 
            
            </Accordion.Header>
          <Accordion.Body>

          <SP_01a_FieldEditor />
  
          </Accordion.Body>
        </Accordion.Item>

  
      </Accordion>
    {/* <SP_01a_FieldEditor /> */} 
      {/* <Helper props={this.props.dev} /> */}
      <Helper props={this.props.dev.sensors_collection_id} />

      
    </div>



</>

    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,

  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(ServicePage);

